import {Component, Input, OnInit} from '@angular/core';
import {GeneralValuationData} from '../models/generalValuationData';
import {
    ParticipantEvaluatorsDict,
    ParticipantOverview,
    ParticipantRatingsDict
} from 'src/app/calibration/_interfaces/participant-overview.interface';
import {BaseClass} from 'src/app/shared/classes/base';
import {ToastController} from '@ionic/angular';
import {TranslationService} from 'src/app/shared/services/translation.service';
import { ConfigService } from 'src/app/shared/services/multi-clients/config.service';

@Component({
    selector: 'app-general-valuation-table',
    templateUrl: './general-valuation-table.component.html',
    styleUrls: ['./general-valuation-table.component.scss'],
})
export class GeneralValuationTableComponent extends BaseClass implements OnInit {
    @Input() user: Partial<ParticipantOverview>;
    @Input() isManagement: boolean = false;

    public showTooltips: boolean = true;

    public canEditManagerEvaluation = false;
    public anyCalculated: boolean = false;
    public goalsCalculated: boolean = false;
    public principleCalculated: boolean = false;
    public finalCalculated: boolean = false;
    public useTranslationOnOverallEvaluation: boolean;
    public instructions = {
        relatedQuestionsUsed: 'manageVersion.calculate.instructions',
        formula: 'manageVersion.formula.instructions',
    }

    constructor(
        protected _toastController: ToastController,
        protected _translationService: TranslationService,
        private _configService: ConfigService
    ) {
        super(_toastController, _translationService);
    }

    ngOnInit() {
        this.useTranslationOnOverallEvaluation = this._configService.settings.features.useTranslationOnOverallEvaluation;
        this.selectedLanguage = this._translationService.getSelectedLanguage();
        this.anyCalculated =
            this.user
            && (
                (this.user.selfEvaluation
                    && (this.user.selfEvaluation.finalGoalsSelfEvaluationRelatedQuestionsUsed
                        || this.user.selfEvaluation.finalPrinciplesSelfEvaluationRelatedQuestionsUsed
                        || this.user.selfEvaluation.finalSelfEvaluationRelatedQuestionsUsed))
                || (this.user.managerEvaluation
                    && (this.user.managerEvaluation.finalGoalsManagerEvaluationRelatedQuestionsUsed
                        || this.user.managerEvaluation.finalPrinciplesManagerEvaluationRelatedQuestionsUsed
                        || this.user.managerEvaluation.finalManagerEvaluationRelatedQuestionsUsed))
            );
        this.goalsCalculated = (this.user && this.user.selfEvaluation && this.user.selfEvaluation.finalGoalsSelfEvaluationRelatedQuestionsUsed)
            || (this.user && this.user.managerEvaluation && this.user.managerEvaluation.finalGoalsManagerEvaluationRelatedQuestionsUsed)
            || false;
        this.principleCalculated = (this.user && this.user.selfEvaluation && this.user.selfEvaluation.finalPrinciplesSelfEvaluationRelatedQuestionsUsed)
            || (this.user && this.user.managerEvaluation && this.user.managerEvaluation.finalPrinciplesManagerEvaluationRelatedQuestionsUsed)
            || false;
        this.finalCalculated = (this.user && this.user.selfEvaluation && this.user.selfEvaluation.finalSelfEvaluationRelatedQuestionsUsed)
            || (this.user && this.user.managerEvaluation && this.user.managerEvaluation.finalManagerEvaluationRelatedQuestionsUsed)
            || false;

    }

    public getTotalEvaluators(ratings: ParticipantRatingsDict): number {
        let total = 0;
        if (!ratings) return total;

        const keys = Object.keys(ratings);

        keys.forEach(key => {
            total = total + ratings[key];
        });

        return total;
    }

    public getAllEvaluators(ratings: ParticipantEvaluatorsDict): string {
        if (ratings) {
            let evaluators = '';
            if (!ratings) return evaluators;

            const keys = Object.keys(ratings);

            keys.forEach(key => {
                evaluators = evaluators + ratings[key];
            });

            return evaluators;
        }
        return null;
    }

    public getRatingTotals(rating: string): number {
        return (this.user.ratings.freeEvaluationRatings ? this.user.ratings.freeEvaluationRatings[rating] : null)
            + (this.user.ratings.directReportRatings ? this.user.ratings.directReportRatings[rating] : null)
            + (this.user.ratings.threeSixtyRatings ? this.user.ratings.threeSixtyRatings[rating] : null);
    }

    public getRatingTotalEvaluators(rating: string): string {
        return (this.user.evaluators.freeEvaluators ? this.user.evaluators.freeEvaluators[rating] : null)
            + (this.user.evaluators.directReportEvaluators ? this.user.evaluators.directReportEvaluators[rating] : null)
            + (this.user.evaluators.threeSixtyEvaluators ? this.user.evaluators.threeSixtyEvaluators[rating] : null);
    }

}
